import { Col, Flex, Row } from 'antd'

/**
 * returns JSX for managing staff
 */
function ManageStaff() {
  return (
    <>
      {/* navigation */}
      <Flex vertical gap="20px">
        <Row gutter={10} className="main-navigation">
          <Col>
            <Flex
              gap="10px"
              className="main-navigation__heading"
              align="center"
            >
              <h3>Manage Staff</h3>
            </Flex>
          </Col>
        </Row>
      </Flex>
    </>
  )
}

export default ManageStaff
